import React, { Component } from 'react';
import { clearStoredSession } from './session';
import { getAuth0Client } from './auth0Client';

class Logout extends Component {
  componentDidMount() {
    clearStoredSession();
    const returnTo = typeof window !== 'undefined' ? window.location.origin : 'https://dashboard.gophr.app';
    getAuth0Client().logout({ logoutParams: { returnTo } });
  }

  render() {
    return <div style={{ minHeight: '100vh', background: '#1e1e2e' }} />;
  }
}

export default Logout;